import {
  Injectable,
  Signal,
  WritableSignal,
  computed,
  inject,
  signal,
} from '@angular/core';

import { AuthStateService } from './auth-state.service';
import { DialogService } from './dialog.service';

export type MoneyAccess = 'allowed' | 'setup-required' | 'verification-required';

export const TWO_FACTOR_REQUIRED_DIALOG_ID = 'two-factor-required';

@Injectable({ providedIn: 'root' })
export class TwoFactorGateService {
  public readonly access: Signal<MoneyAccess>;
  public readonly refusal: Signal<MoneyAccess>;

  private readonly authState = inject(AuthStateService);
  private readonly dialog = inject(DialogService);
  private readonly refusalSignal: WritableSignal<MoneyAccess> =
    signal<MoneyAccess>('setup-required');
  private pendingRetry: (() => void) | null = null;

  constructor() {
    this.refusal = this.refusalSignal.asReadonly();
    this.access = computed((): MoneyAccess => {
      if (!this.authState.user()?.twoFactorEnabled) {
        return 'setup-required';
      }

      return this.authState.twoFactorVerified()
        ? 'allowed'
        : 'verification-required';
    });
  }

  public ensureMoneyAccess(retry?: () => void): boolean {
    const access = this.access();

    if (access === 'allowed') {
      return true;
    }
    this.pendingRetry = access === 'verification-required' ? (retry ?? null) : null;
    this.refusalSignal.set(access);
    this.dialog.open(TWO_FACTOR_REQUIRED_DIALOG_ID);

    return false;
  }

  public completeStepUp(): void {
    const retry = this.pendingRetry;

    this.pendingRetry = null;
    retry?.();
  }

  public abandonStepUp(): void {
    this.pendingRetry = null;
  }
}
